<template>
  <div id="contenedor-actividad" style="width: 100%;">
    <v-card width="100%" class="mt-2" style="min-height: 150px;" elevation="1">
      <v-card-title class="pb-2">
        <span>
          {{ $moment(actividad.fecha ? actividad.fecha : actividad.createdAt).format("D/MM/YYYY") }}
        </span>
        <span class="text-caption grey--text text--darken-1 ml-2">
          <fecha-humano
            :fecha="actividad.createdAt">
          </fecha-humano>
        </span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <div>
          <h4>
            <!-- Descripcion -->
            <cortar-textos :texto="actividad.descripcion"> </cortar-textos>
          </h4>
        </div>
      </v-card-text>
      <v-card-text v-if="actividad.imagenes && actividad.imagenes.length > 0" class="pt-0">
        <v-row dense>
          <!-- Imagenes -->
          <template v-for="imagen in actividad.imagenes">
            <template v-if="typeof imagen === 'string'">
              <v-col cols="auto" :key="imagen">
                <v-img
                  :src="`${$urlFileServer}/${imagen}/thumbnail`"
                  :lazy-src="`${$urlFileServer}/${imagen}/thumbnail`"
                  height="50"
                  width="50"
                  contain
                  class="blue-grey darken-4"
                  style="cursor: pointer;"
                  @click="mostrarImagenes(actividad)"
                >
                </v-img>
              </v-col>
            </template>
          </template>
        </v-row>
      </v-card-text>
      <v-card-text v-else class="py-0">
        <v-row>
          <v-col cols="12">
            <v-alert dense outlined color="info" icon="mdi-information-outline">
              Este reporte no contiene imagenes
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text>
        <v-divider class="mb-2"></v-divider>
        <v-row>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-chip
                v-on="on"
                class="mt-2 ml-2"
                outlined
                :color="getEtiquetasColor(actividad.verificacionSeguridad)"
              >
                <v-icon left>mdi-shield-check-outline </v-icon>
                {{ getEtiquetaTexto(actividad.verificacionSeguridad) }}
              </v-chip>
            </template>
            <span>
              Verificacion de Seguridad
            </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-chip
                v-on="on"
                class="mt-2 ml-2"
                outlined
                :color="getEtiquetasColor(actividad.higieneLimpiezaTrabajos)"
              >
                <v-icon left>mdi-broom </v-icon>
                {{ getEtiquetaTexto(actividad.higieneLimpiezaTrabajos) }}
              </v-chip>
            </template>
            <span>
              Higiene y Limpieza de los Trabajos
            </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-chip
                v-on="on"
                class="mt-2 ml-2"
                outlined
                :color="getEtiquetasColor(actividad.inventarioInsumosPresentes)"
              >
                <v-icon left>mdi-bulldozer</v-icon>
                {{ getEtiquetaTexto(actividad.inventarioInsumosPresentes) }}
              </v-chip>
            </template>
            <span>
              Inventario de Insumos Presentes
            </span>
          </v-tooltip>
        </v-row>
      </v-card-text>
      <!-- Acciones -->
      <v-card-actions v-if="!soloLectura">
        <v-spacer></v-spacer>
        <!-- Editar actividad -->
        <v-btn icon @click="editar(actividad)">
          <v-icon>
            mdi-pencil
          </v-icon>
        </v-btn>
        <!-- Borrar actividad -->
        <v-btn icon @click="borrar(actividad)">
          <v-icon>
            mdi-delete
          </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';
import CortarTextos from '@/components/CortarTextos.vue';
import FechaHumano from '@/components/FechaHumano.vue';

export default {
  name: 'CardListadoActividades',
  components: {
    CortarTextos,
    FechaHumano,
  },
  props: {
    actividad: {
      type: Object,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    getEtiquetaTexto(valor) {
      if (valor === 1) {
        return 'BIEN';
      }
      if (valor === 2) {
        return 'REGULAR';
      }
      if (valor === 3) {
        return 'MAL';
      }
      return 'SIN CALIFICAR';
    },
    getEtiquetasColor(valor) {
      if (valor === 1) {
        return 'success';
      }
      if (valor === 2) {
        return 'warning';
      }
      if (valor === 3) {
        return 'red';
      }
      return 'grey';
    },
    mostrarImagenes(actividad) {
      const imagenes = [];
      actividad.imagenes.forEach((imagen) => {
        if (typeof imagen === 'string') {
          imagenes.push({
            url: `${this.$urlFileServer}/${imagen}`,
            titulo: `${actividad.contrato.numero}_${this.$moment(actividad.fecha).format(
              'D-MM-YYYY',
            )}`,
          });
        }
      });
      eventBus.$emit('mostrar-imagenes-actividad-contrato', imagenes);
    },
    editar(actividad) {
      eventBus.$emit('editar-actividad-contrato', actividad);
    },
    borrar(actividad) {
      eventBus.$emit('eliminar-actividad-contrato', actividad);
    },
  },
};
</script>

<style lang="scss"></style>
